import {
  slab, goal, sign, checkpoint, edgeLights, gravfield, wind,
} from '../kit.js';

/**
 * Intro sector: the current. Two lessons. A jetstream (wind composed with
 * gentle gravity) carries anyone who jumps in across the first chasm, and
 * a bare crosswind bends the second drop onto an offset platform. Ground
 * friction eats wind, so the current only owns the air; the sector never
 * needs that sentence said, because every crossing begins by leaving the
 * ground.
 */
export default {
  id: 'zephyr',
  name: 'ZEPHYR',
  blurb: 'The current carries. Jump in.',
  mode: { type: 'sprint', par: 20 },
  redline: { seconds: 14 },   // docs/REDLINE.md; seeded from the board, honesty pass pending
  spawn: { p: [0, 0.4, 8], yaw: 0 },
  killY: -75,
  env: {
    fog: 0x0a1622,
    fogDensity: 0.0040,
    sky: { zenith: 0x030a14, horizon: 0x0e2a40, glow: 0x2a8ac8, aurora: 0x9adfff },
    floorY: -220,
  },
  objects: [
    // ---- start deck
    slab(0, 0, 0, 24, 24, 'plate', 1.4),
    ...edgeLights(0, 0, 0, 24, 24, 'cyan'),
    checkpoint(0, 0, 6),
    sign(0, 3.2, 5, 0, ['ZEPHYR', 'THE CURRENT CARRIES', 'JUMP IN'], '#9adfff'),

    // ---- crossing one: a jetstream over a descending chasm. The low
    // gravity is what lets a plain walk-off survive; the wind does the rest.
    gravfield(0, -14, -25, 22, 22, 30),
    wind(0, -14, -25, 20, 22, 28, [0, 0, -1], 18, 26),
    slab(0, -10, -52, 26, 28, 'plate', 1.4),
    ...edgeLights(0, -10, -52, 26, 28, 'cyan'),
    checkpoint(0, -10, -48),
    sign(0, -6.8, -49, 0, ['THE WIND BENDS A FALL', 'STEP OFF'], '#ffb020'),

    // ---- crossing two: a bare crosswind in a 30m drop; the fall drifts
    // down-course onto the offset platform.
    wind(0, -44, -81, 22, 36, 30, [0, 0, -1], 20, 26),
    slab(0, -40, -96, 28, 26, 'plate', 1.6),
    ...edgeLights(0, -40, -96, 28, 26, 'lime'),
    checkpoint(0, -40, -90),
    goal(0, -40, -102, 0),
  ],
};
